import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { Input } from '@/components/ui/input';

const ACTION_TONE = {
  'listing.published': 'bg-accent text-accent-foreground',
  'listing.rejected': 'bg-destructive/20 text-destructive',
  'listing.suspended': 'bg-terracotta/20 text-terracotta',
  'user.role_change': 'bg-terracotta/20 text-terracotta',
  'user.suspend': 'bg-destructive/20 text-destructive',
  'user.verify': 'bg-accent text-accent-foreground',
};

export default function AdminAuditLog() {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [q, setQ] = useState('');

  useEffect(() => {
    api.get('/admin/audit-log', { params: { limit: 300, action: q || undefined } })
       .then(r => { setItems(r.data.entries || []); setTotal(r.data.total || 0); });
  }, [q]);

  return (
    <div className="space-y-6">
      <header>
        <div className="text-xs uppercase tracking-[0.2em] font-bold text-terracotta">Audit Log</div>
        <h1 className="font-display text-3xl md:text-4xl tracking-tighter mt-2">Registro azioni amministrative</h1>
        <p className="mt-2 text-sm text-muted-foreground">Ogni azione compiuta da un admin viene tracciata: chi, cosa, quando, su quale oggetto e con quale motivazione.</p>
      </header>

      <Input placeholder="Filtra per azione (es. listing.published, user.role_change)" value={q} onChange={e=>setQ(e.target.value)} className="max-w-md"/>
      <div className="text-xs text-muted-foreground">{total} voci totali</div>

      <div className="rounded-2xl border border-border bg-card overflow-hidden">
        {items.length===0 ? <div className="p-10 text-sm text-muted-foreground text-center">Nessuna voce nel registro</div> :
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-secondary/60">
                <tr className="text-left text-xs uppercase tracking-widest text-muted-foreground">
                  <th className="px-4 py-3">Data/Ora</th>
                  <th className="px-4 py-3">Admin</th>
                  <th className="px-4 py-3">Ruolo</th>
                  <th className="px-4 py-3">Azione</th>
                  <th className="px-4 py-3">Oggetto</th>
                  <th className="px-4 py-3">Motivo</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-border">
                {items.map(a => (
                  <tr key={a.audit_id}>
                    <td className="px-4 py-3 text-xs text-muted-foreground whitespace-nowrap">{new Date(a.created_at).toLocaleString('it-IT')}</td>
                    <td className="px-4 py-3">{a.admin_email}</td>
                    <td className="px-4 py-3"><span className="text-[10px] uppercase tracking-widest font-bold px-2 py-0.5 rounded-full bg-secondary">{a.admin_role}</span></td>
                    <td className="px-4 py-3"><span className={`text-[10px] uppercase tracking-widest font-bold px-2 py-0.5 rounded-full ${ACTION_TONE[a.action]||'bg-secondary'}`}>{a.action}</span></td>
                    <td className="px-4 py-3 font-mono text-xs">{a.target_type}: {a.target_id}</td>
                    <td className="px-4 py-3 text-xs text-muted-foreground max-w-md">
                      {a.reason || <span className="opacity-50">—</span>}
                      {a.metadata?.from && a.metadata?.to && (
                        <div className="text-[10px] mt-1">{a.metadata.from} → {a.metadata.to}</div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>}
      </div>
    </div>
  );
}
